import type { Canvas, FabricObject } from 'fabric';
import { getObjectsByLayerId } from '../layer-id';
import type { CanonicalTransforms } from '../resolve-frame';
import type { ClipTransform } from '../../timeline/types';

/**
 * Derived geometry still lives on the canvas, so transforms come from there.
 * Existing entries win, so a layer captured before playback keeps what it had.
 */
export const readCanonicalTransforms = (canvas: Canvas, into: CanonicalTransforms = {}): CanonicalTransforms => {
  getObjectsByLayerId(canvas).forEach((obj, id) => {
    if (into[id]) return;
    into[id] = {
      left: obj.left ?? 0,
      top: obj.top ?? 0,
      scaleX: obj.scaleX ?? 1,
      scaleY: obj.scaleY ?? 1,
      rotation: obj.angle ?? 0,
      opacity: obj.opacity ?? 1
    };
  });
  return into;
};

export const writeTransform = (obj: FabricObject, transform: ClipTransform): void => {
  obj.set({
    left: transform.left,
    top: transform.top,
    scaleX: transform.scaleX,
    scaleY: transform.scaleY,
    angle: transform.rotation,
    opacity: transform.opacity
  });
  obj.setCoords();
};
